import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, ClockIcon } from 'lucide-react';
export function PricingCards() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const calculateTimeLeft = () => {
      const targetDate = new Date(new Date().getFullYear(), 6, 31, 23, 59, 59); // July 31st (month is 0-indexed)
      const now = new Date();
      // If we're past July 31st, use next year
      if (now > targetDate) {
        targetDate.setFullYear(targetDate.getFullYear() + 1);
      }
      const difference = targetDate.getTime() - now.getTime();
      if (difference > 0) {
        return {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        };
      }
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
    };
    // Initial calculation
    setTimeLeft(calculateTimeLeft());
    // Update the countdown every second
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    // Clear the interval when component unmounts
    return () => clearInterval(timer);
  }, []);
  return <div className="w-full my-12" data-id="element-289">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-290">
        You can join Unfreeze, the full 4-week guided program, including:
      </h2>
      <div className="bg-gradient-to-r from-purple-50 to-teal-50 p-8 rounded-xl shadow-md my-8" data-id="element-291">
        <ul className="space-y-4 max-w-2xl mx-auto" data-id="element-292">
          <li className="flex items-start" data-id="element-293">
            <div className="flex-shrink-0 w-6 h-6 mt-1 text-purple-600" data-id="element-294">
              <CheckIcon className="w-6 h-6" data-id="element-295" />
            </div>
            <p className="ml-3 text-lg text-gray-800 font-medium" data-id="element-296">
              All 8+ science-backed video practices
            </p>
          </li>
          <li className="flex items-start" data-id="element-297">
            <div className="flex-shrink-0 w-6 h-6 mt-1 text-purple-600" data-id="element-298">
              <CheckIcon className="w-6 h-6" data-id="element-299" />
            </div>
            <p className="ml-3 text-lg text-gray-800 font-medium" data-id="element-300">
              The printable 30+ page workbook
            </p>
          </li>
          <li className="flex items-start" data-id="element-301">
            <div className="flex-shrink-0 w-6 h-6 mt-1 text-purple-600" data-id="element-302">
              <CheckIcon className="w-6 h-6" data-id="element-303" />
            </div>
            <p className="ml-3 text-lg text-gray-800 font-medium" data-id="element-304">
              Access to our next live group support call
            </p>
          </li>
          <li className="flex items-start" data-id="element-305">
            <div className="flex-shrink-0 w-6 h-6 mt-1 text-purple-600" data-id="element-306">
              <CheckIcon className="w-6 h-6" data-id="element-307" />
            </div>
            <p className="ml-3 text-lg text-gray-800 font-medium" data-id="element-308">
              And lifetime access to revisit any time you need
            </p>
          </li>
        </ul>
        <div className="text-center mt-8 mb-4" data-id="element-309">
          <p className="text-xl text-gray-800 mb-2" data-id="element-310">All for just</p>
          <p className="text-3xl font-bold" data-id="element-311">
            <span className="text-gray-500 line-through mr-2" data-id="element-312">$69</span>
            <span className="text-purple-700" data-id="element-313">$29</span>
            <span className="text-lg font-normal text-gray-700 ml-1" data-id="element-314">
              (one-time)
            </span>
          </p>
          <p className="text-gray-700 mt-2" data-id="element-315">
            No pressure. No subscription. No expiration.
          </p>
        </div>
      </div>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mt-10 mb-6 text-center" data-id="element-316">
        But—if you want a complete solution for chronic pain, tension, and
        emotional numbness...
      </h2>
      <p className="text-lg text-gray-700 text-center mb-6" data-id="element-317">
        If you want ongoing access to all past, present, and future healing
        programs—including:
      </p>
      <div className="flex flex-col items-center mb-8" data-id="element-318">
        <div className="bg-white px-6 py-3 rounded-lg shadow-md border border-purple-200 mb-2" data-id="element-319">
          <p className="text-gray-800 font-medium" data-id="element-320">Managing Chronic Fatigue</p>
        </div>
        <div className="bg-white px-6 py-3 rounded-lg shadow-md border border-purple-200 mb-2" data-id="element-321">
          <p className="text-gray-800 font-medium" data-id="element-322">Coping with Grief & Loss</p>
        </div>
        <div className="bg-white px-6 py-3 rounded-lg shadow-md border border-purple-200" data-id="element-323">
          <p className="text-gray-800 font-medium" data-id="element-324">Rewiring Trauma Reactions</p>
        </div>
      </div>
      <p className="text-lg text-gray-700 text-center mb-6" data-id="element-325">
        …plus every future monthly program we release and ongoing access to all
        live healing calls…
      </p>
      <p className="text-xl text-gray-800 font-bold text-center mb-6" data-id="element-326">
        Then you might want to start your Neurotoned Membership so you can
        unlock this entire program—plus our full library and all future
        content—for just:
      </p>
      <div className="text-center mb-8" data-id="element-327">
        <p className="text-4xl font-bold text-purple-700" data-id="element-328">$90/year</p>
        <p className="text-gray-700 mt-2" data-id="element-329">That's less than $8 a month to:</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-md border border-gray-200 max-w-2xl mx-auto mb-10" data-id="element-330">
        <ul className="space-y-4" data-id="element-331">
          <li className="flex items-start" data-id="element-332">
            <div className="flex-shrink-0 w-5 h-5 mt-1 text-purple-600" data-id="element-333">
              <CheckIcon className="w-5 h-5" data-id="element-334" />
            </div>
            <p className="ml-3 text-base text-gray-700" data-id="element-335">
              Gently reset your nervous system all year long
            </p>
          </li>
          <li className="flex items-start" data-id="element-336">
            <div className="flex-shrink-0 w-5 h-5 mt-1 text-purple-600" data-id="element-337">
              <CheckIcon className="w-5 h-5" data-id="element-338" />
            </div>
            <p className="ml-3 text-base text-gray-700" data-id="element-339">
              Get continuous guidance from trauma-informed experts
            </p>
          </li>
          <li className="flex items-start" data-id="element-340">
            <div className="flex-shrink-0 w-5 h-5 mt-1 text-purple-600" data-id="element-341">
              <CheckIcon className="w-5 h-5" data-id="element-342" />
            </div>
            <p className="ml-3 text-base text-gray-700" data-id="element-343">
              Join regular live support calls and stay connected to a healing
              community
            </p>
          </li>
          <li className="flex items-start" data-id="element-344">
            <div className="flex-shrink-0 w-5 h-5 mt-1 text-purple-600" data-id="element-345">
              <CheckIcon className="w-5 h-5" data-id="element-346" />
            </div>
            <p className="ml-3 text-base text-gray-700" data-id="element-347">
              Explore creative, body-first practices designed for where you
              actually are
            </p>
          </li>
        </ul>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8" data-id="element-348">
        {/* Membership Card */}
        <div className="bg-white border-2 border-purple-400 rounded-xl shadow-lg overflow-hidden relative order-2 md:order-1" data-id="element-349">
          <div className="w-full" data-id="element-350">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uUA5vfn2aoPYgRbaitC7ga/Mockups_%2814%29.png" alt="Neurotoned Membership" className="w-full h-auto object-cover" data-id="element-351" />
          </div>
          <div className="absolute top-0 right-0 bg-purple-600 text-white px-4 py-1 rounded-bl-lg font-semibold text-sm" data-id="element-352">
            BEST VALUE
          </div>
          <div className="p-6 bg-gradient-to-r from-purple-500 to-teal-500 text-center" data-id="element-353">
            <h3 className="text-xl font-bold text-white mb-1" data-id="element-354">
              Neurotoned Membership
            </h3>
            <p className="text-white text-sm mb-2" data-id="element-355">
              Your complete solution for neck pain, tension & emotional healing
            </p>
          </div>
          <div className="p-6" data-id="element-356">
            <p className="font-bold text-purple-800 mb-4" data-id="element-357">
              🔥 Includes 4-week creative reset for emotional numbness PLUS:
            </p>
            <ul className="space-y-4 mb-6" data-id="element-358">
              <li className="flex items-start" data-id="element-359">
                <div className="flex-shrink-0 w-5 h-5 mt-1" data-id="element-360">
                  <CheckIcon className="w-5 h-5 text-purple-500" data-id="element-361" />
                </div>
                <div className="ml-3" data-id="element-362">
                  <p className="text-base text-gray-700 font-semibold" data-id="element-363">
                    Targeted neck pain relief protocols that:
                  </p>
                  <ul className="list-disc pl-6 text-gray-700" data-id="element-364">
                    <li data-id="element-365">Release deep neck & shoulder tension</li>
                    <li data-id="element-366">Reduce chronic headaches & migraines</li>
                    <li data-id="element-367">Restore natural neck mobility & alignment</li>
                  </ul>
                </div>
              </li>
              <li className="flex items-start" data-id="element-368">
                <div className="flex-shrink-0 w-5 h-5 mt-1" data-id="element-369">
                  <CheckIcon className="w-5 h-5 text-purple-500" data-id="element-370" />
                </div>
                <p className="ml-3 text-base text-gray-700" data-id="element-371">
                  <span className="font-semibold" data-id="element-372">Chronic Fatigue Program</span>{' '}
                  - Gentle energy restoration practices that work even when
                  you're exhausted
                </p>
              </li>
              <li className="flex items-start" data-id="element-373">
                <div className="flex-shrink-0 w-5 h-5 mt-1" data-id="element-374">
                  <CheckIcon className="w-5 h-5 text-purple-500" data-id="element-375" />
                </div>
                <p className="ml-3 text-base text-gray-700" data-id="element-376">
                  <span className="font-semibold" data-id="element-377">
                    Monthly live healing calls
                  </span>{' '}
                  with specific neck & upper body tension release techniques
                </p>
              </li>
              <li className="flex items-start" data-id="element-378">
                <div className="flex-shrink-0 w-5 h-5 mt-1" data-id="element-379">
                  <CheckIcon className="w-5 h-5 text-purple-500" data-id="element-380" />
                </div>
                <p className="ml-3 text-base text-gray-700" data-id="element-381">
                  <span className="font-semibold" data-id="element-382">Exclusive access</span> to all
                  future pain relief & nervous system reset programs
                </p>
              </li>
            </ul>
            <div className="mb-6" data-id="element-383">
              <p className="text-gray-700 mb-1" data-id="element-384">Annual Price:</p>
              <div className="flex items-baseline" data-id="element-385">
                <span className="text-gray-500 line-through text-lg mr-2" data-id="element-386">
                  $180
                </span>
                <span className="text-3xl font-bold text-purple-600" data-id="element-387">$90</span>
                <span className="text-gray-700 ml-1" data-id="element-388">/year</span>
              </div>
              <p className="text-gray-600 text-sm mt-1" data-id="element-389">
                That's just $7.50/month for complete neck pain relief
              </p>
            </div>
            <div className="text-red-600 text-sm font-medium flex items-center justify-center mb-3" data-id="element-390">
              <ClockIcon className="w-4 h-4 mr-1" data-id="element-391" />
              Enrollment open for a limited time
            </div>
            <CTAButton text="Get Complete Pain Relief" className="w-full bg-gradient-to-r from-purple-500 to-teal-500 hover:from-purple-600 hover:to-teal-600" href="https://www.neurotoned.com/offers/wMu8NCLb/checkout?coupon_code=50OFFNEUROYEARLY2025" data-id="element-392" />
          </div>
        </div>
        {/* One-Time Access Card */}
        <div className="bg-white border border-gray-200 rounded-xl shadow-md overflow-hidden order-1 md:order-2" data-id="element-393">
          <div className="w-full" data-id="element-394">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6m7oNuUA2xGsixMwp91Mse/Mockups_%2812%29.png" alt="Unfreeze Program" className="w-full h-auto object-cover" data-id="element-395" />
          </div>
          <div className="p-6 bg-gradient-to-r from-gray-100 to-gray-200 text-center" data-id="element-396">
            <h3 className="text-xl font-bold text-gray-800 mb-1" data-id="element-397">
              Unfreeze Program
            </h3>
            <p className="text-gray-600 text-sm mb-2" data-id="element-398">
              Start your journey to emotional reconnection
            </p>
          </div>
          <div className="p-6" data-id="element-399">
            <p className="font-bold text-gray-700 mb-4" data-id="element-400">💡 Includes:</p>
            <ul className="space-y-4 mb-6" data-id="element-401">
              <li className="flex items-start" data-id="element-402">
                <div className="flex-shrink-0 w-5 h-5 mt-1" data-id="element-403">
                  <CheckIcon className="w-5 h-5 text-teal-500" data-id="element-404" />
                </div>
                <p className="ml-3 text-base text-gray-700" data-id="element-405">
                  <span className="font-semibold" data-id="element-406">
                    4 powerful video practices
                  </span>{' '}
                  that release tension patterns causing neck pain
                </p>
              </li>
              <li className="flex items-start" data-id="element-407">
                <div className="flex-shrink-0 w-5 h-5 mt-1" data-id="element-408">
                  <CheckIcon className="w-5 h-5 text-teal-500" data-id="element-409" />
                </div>
                <p className="ml-3 text-base text-gray-700" data-id="element-410">
                  <span className="font-semibold" data-id="element-411">30+ page workbook</span> with
                  targeted exercises for upper body tension & emotional release
                </p>
              </li>
              <li className="flex items-start" data-id="element-412">
                <div className="flex-shrink-0 w-5 h-5 mt-1" data-id="element-413">
                  <CheckIcon className="w-5 h-5 text-teal-500" data-id="element-414" />
                </div>
                <p className="ml-3 text-base text-gray-700" data-id="element-415">
                  <span className="font-semibold" data-id="element-416">
                    Live group healing session
                  </span>{' '}
                  focused on neck & shoulder relief techniques
                </p>
              </li>
              <li className="flex items-start" data-id="element-417">
                <div className="flex-shrink-0 w-5 h-5 mt-1" data-id="element-418">
                  <CheckIcon className="w-5 h-5 text-teal-500" data-id="element-419" />
                </div>
                <p className="ml-3 text-base text-gray-700" data-id="element-420">
                  <span className="font-semibold" data-id="element-421">Lifetime access</span> to
                  revisit these powerful relief techniques anytime
                </p>
              </li>
            </ul>
            <div className="mb-6" data-id="element-422">
              <p className="text-gray-700 mb-1" data-id="element-423">One-Time Price:</p>
              <div className="flex items-baseline" data-id="element-424">
                <span className="text-gray-500 line-through text-lg mr-2" data-id="element-425">
                  $69
                </span>
                <span className="text-3xl font-bold text-gray-800" data-id="element-426">$29</span>
                <span className="text-gray-700 ml-1" data-id="element-427">USD</span>
              </div>
              <p className="text-gray-600 text-sm mt-1" data-id="element-428">
                No subscriptions. No expiration. Immediate relief.
              </p>
            </div>
            <div className="text-red-600 text-sm font-medium flex items-center justify-center mb-3" data-id="element-429">
              <ClockIcon className="w-4 h-4 mr-1" data-id="element-430" />
              Enrollment open for a limited time
            </div>
            <CTAButton text="Start Your Relief Now" className="w-full" href="https://www.neurotoned.com/offers/LD3TSKZA?coupon_code=20OFFCHRONICFATIGUE2025" data-id="element-431" />
          </div>
        </div>
      </div>
      <div className="bg-red-50 border border-red-200 rounded-lg p-6 mt-10 mb-6" data-id="element-432">
        <div className="flex items-center justify-center mb-3" data-id="element-433">
          <ClockIcon className="w-6 h-6 text-red-600 mr-2" data-id="element-434" />
          <p className="text-xl font-bold text-red-600" data-id="element-435">
            This transformative program is only available for enrollment for a
            limited time
          </p>
        </div>
        <div className="flex justify-center" data-id="element-436">
          <div className="grid grid-cols-4 gap-2 text-center" data-id="element-437">
            <div className="bg-white p-2 rounded-lg shadow-sm" data-id="element-438">
              <div className="text-2xl font-bold text-gray-800" data-id="element-439">
                {timeLeft.days}
              </div>
              <div className="text-xs text-gray-600" data-id="element-440">Days</div>
            </div>
            <div className="bg-white p-2 rounded-lg shadow-sm" data-id="element-441">
              <div className="text-2xl font-bold text-gray-800" data-id="element-442">
                {timeLeft.hours}
              </div>
              <div className="text-xs text-gray-600" data-id="element-443">Hours</div>
            </div>
            <div className="bg-white p-2 rounded-lg shadow-sm" data-id="element-444">
              <div className="text-2xl font-bold text-gray-800" data-id="element-445">
                {timeLeft.minutes}
              </div>
              <div className="text-xs text-gray-600" data-id="element-446">Minutes</div>
            </div>
            <div className="bg-white p-2 rounded-lg shadow-sm" data-id="element-447">
              <div className="text-2xl font-bold text-gray-800" data-id="element-448">
                {timeLeft.seconds}
              </div>
              <div className="text-xs text-gray-600" data-id="element-449">Seconds</div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-10 bg-white p-6 rounded-lg shadow-md border border-gray-200" data-id="element-450">
        <div className="flex items-center mb-2" data-id="element-451">
          <div className="w-12 h-12 rounded-full bg-gray-200 mr-3 flex items-center justify-center text-lg font-bold" data-id="element-452">
            K
          </div>
          <div data-id="element-453">
            <h4 className="font-semibold" data-id="element-454">Kelsey M., 52</h4>
            <div className="flex items-center text-gray-500 text-sm" data-id="element-455">
              <span className="mx-2" data-id="element-456">•</span>
              <span data-id="element-457">Verified client</span>
            </div>
          </div>
        </div>
        <div className="flex mb-2" data-id="element-458">
          {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-5 h-5 text-green-500 fill-current" viewBox="0 0 20 20" data-id="element-459">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-460" />
            </svg>)}
        </div>
        <h3 className="font-bold text-lg mb-2" data-id="element-461">
          "After 3 years of chronic neck pain that nothing seemed to help, I
          found this program. Within 2 weeks, my neck tension decreased by 80%."
        </h3>
        <p className="text-gray-700" data-id="element-462">
          I started with just one program, but after seeing how much it helped
          with my neck pain and tension headaches, I upgraded to the full
          membership. The targeted neck protocols have given me back my mobility
          and significantly reduced my pain. For the first time in years, I wake
          up without that familiar ache. Worth every penny.
        </p>
      </div>
      <h2 className="text-2xl font-bold text-gray-800 mt-10 mb-4 text-center" data-id="element-463">
        Whichever option you choose, you're saying yes to freedom from pain and
        a nervous system that feels safe enough to heal.
      </h2>
    </div>;
}